import { GD } from "src/GD"
import { getIssuerRequestContext, isIssuerRequestContextCurrent } from "./issuerRequestContext"

export const refreshBalanceSources = async () => {
	const requestContext = getIssuerRequestContext()
	const [companies, , users] = await Promise.allSettled([
		GD.REQ_COMPANIES.request({ force: true }),
		GD.REQ_TEAMS_LIST.request({ force: true }),
		GD.REQ_USERS.request({ options: { include_teams: true } }),
		GD.REQ_COMPANY_REFRESH.request(),
		GD.REQ_PROFILE.request()
	])
	if (!isIssuerRequestContextCurrent(requestContext)) return

	if (companies.status === "fulfilled" && companies.value.data) {
		GD.S_COMPANY_LIST_UPDATED.invoke(companies.value.data)
	}
	if (users.status === "fulfilled" && users.value.data) {
		GD.S_USERS_LIST_UPDATED.invoke(users.value.data)
	}
	GD.S_COMPANY_ISSUERS_REFRESH.invoke()
}
